































































import Vue from 'vue';
import { IProduct } from '@/common/interfaces/products.interface';
import ProductListMixins from '@/mixins/ProductListMixins';
import FormatHelper from '@/helpers/FormatHelper';
import AddToCartButton from '@/components/layout/buttons/AddToCartButton.vue';
import ProductHelper from '@/helpers/ProductHelper';
import { IMerchandiseItem } from '@/common/interfaces/merchandise.interface';
import PriceText from '@/components/newsingleproductpage/subcomponents/pricetext/PriceText.vue';
import ImageWithErrorMessage
  from '@/components/newsingleproductpage/subcomponents/imagewitherrormessage/ImageWithErrorMessage.vue';
import { ILimitingObject } from '@/common/interfaces/limiting.interface';
import LimitingProductInfoGrid from '@/components/limiting/product-info/LimitingProductInfoGrid.vue';
import ErrorHandlerHelper from '@/helpers/ErrorHandlerHelper';
import CookieHelper from '@/helpers/CookieHelper';
import config from '../../../../config';

interface ISingleIdealSupplementComponent {
  addedToCart: boolean;
  additionalUnitData: string;
  formatHelper: typeof FormatHelper;
  loading: boolean;
  productHelper: typeof ProductHelper;
}

export default Vue.extend({
  name: `SingleIdealSupplement`,
  components: {
    AddToCartButton,
    ImageWithErrorMessage,
    LimitingProductInfoGrid,
    PriceText,
  },
  mixins: [ProductListMixins],
  data(): ISingleIdealSupplementComponent {
    return {
      addedToCart: false,
      additionalUnitData: ``,
      formatHelper: FormatHelper,
      loading: false,
      productHelper: ProductHelper,
    };
  },
  computed: {
    isProductUnavailable(): boolean {
      if(!this.productInfo.deliveryStatusId) {
        return false;
      }

      return config.unavailableDeliveryStatusIds.includes(this.productInfo.deliveryStatusId);
    },
    shoppingAllowed(): boolean {
      return !this.limiting.active || (this.limiting.active && this.limiting.shoppingAllowed);
    },
  },
  props: {
    isPartner: {
      required: true,
      type: Boolean,
    },
    limiting: {
      required: true,
      type: Object as () => ILimitingObject,
    },
    productInfo: {
      required: true,
      type: Object as () => IProduct,
    },
    selectedCartId: {
      required: true,
      type: Number,
    },
  },
  async mounted(): Promise<void> {
    await this.setAdditionalUnit();
  },
  methods: {
    async addItemToCart(): Promise<void> {
      this.loading = true;
      try {
        const merchandiseItem: IMerchandiseItem | null = await this.$cartService.addItemToCartWithProductInfo(this.productInfo, this.isPartner, 1, this.selectedCartId);
        if(merchandiseItem) {
          this.$emit(`open:merchandise-overlay`, merchandiseItem);
        }
        this.loading = false;
        this.addedToCart = true;
        setTimeout(() => {
          this.addedToCart = false;
        }, 2000);
      } catch (err) {
        ErrorHandlerHelper.handleError(err as Error, { logToConsole: true });
        this.loading = false;
      }
    },
    async getPriceString(price: number | null): Promise<string> {
      if(!this.$currencyService.hasCurrencies()) {
        await this.$currencyService.fetchCurrencies();
      }
      const currencySymbol = this.$currencyService.getCurrencySymbol(this.productInfo.currency);
      return `${currencySymbol} ${FormatHelper.formatPrice(price)}`;
    },
    async setAdditionalUnit(): Promise<void> {
      const wpProductData = await this.$wpApiService.getExtendedSingleProductData(
        this.productInfo.link.split(`/`)[2],
        CookieHelper.getLanguage(),
        this.productInfo.image,
      );
      if(this.productInfo.basePrice.brutto && wpProductData.unitPriceData.amount !== null && wpProductData.unitPriceData.amount > 0 && wpProductData.unitPriceData.type !== null) {
        const { text, unitPriceType } = ProductHelper.formatAdditionalUnitPrice(this.productInfo, wpProductData.unitPriceData, this.isPartner);
        this.additionalUnitData = text.replaceAll(`{{unitPriceType}}`, this.$t(unitPriceType));
      }
    },
  },
});
